module.exports = __webpack_public_path__ + "static/media/48392413_2308759145865930_7411442793437986816_o.de4bb17b.jpg";